import React, { Fragment } from "react";
import { connect } from "react-redux";
import { ApplicationState, ConnectedReduxProps } from "@reducers/index";
import { Job } from "@models/job";
import {
  deleteRequest,
  fetchRequest,
  createRequest,
  updateRequest
} from "@actions/job";
import JobForm from "@components/jobs/Form";
import jobApi from "@api/job";
import { injectIntl } from "react-intl";

interface PropsFromState {
  loading: boolean;
  data: Job[];
  errors?: string;
  count: number;
}

interface PropsFromDispatch {
  fetchRequest: typeof fetchRequest;
  deleteRequest: typeof deleteRequest;
}

// Combine both state + dispatch props - as well as any props we want to pass - in a union type.
type AllProps = PropsFromState & PropsFromDispatch & ConnectedReduxProps;

class JobFormPage extends React.Component<AllProps> {
  state = {
    job: null,
    job_id: this.props.match.params.id,
    is_fetched: false
  };

  componentDidMount() {
    if (this.state.job_id) {
      this.fetchItem();
    }
  }

  fetchItem = () => {
    jobApi
      .getItem({
        params: {
          id: this.state.job_id
        }
      })
      .then(({ data }) => {
        this.setState({
          job: data
        });
      })
      .catch(error => {
      });
  };

  getContent = () => {
    if (this.state.job_id && !this.state.job) {
      return null;
    }

    return (
      <JobForm
        job={this.state.job}
        intl={this.props.intl}
        listUrl={"/jobs"}
        history={this.props.history}
        updateRequest={this.props.updateRequest}
        createRequest={this.props.createRequest}
      />
    );
  };

  render() {
    return <Fragment>{this.getContent()}</Fragment>;
  }
}

const mapStateToProps = ({ jobs }: ApplicationState) => ({
  loading: jobs.loading,
  errors: jobs.errors
});

const mapDispatchToProps = {
  createRequest,
  updateRequest
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(injectIntl(JobFormPage));
